import React, { useState } from "react";
import Navbar from "../../components/marketplace/nav/nav";
import Security from "../../components/profile/security/security";
import CardsFooter from "../../components/marketplace/footer/footer";

const SecuritySettings = () => {
  return (
    <>
    <Navbar />
    <Security />
    <CardsFooter />
    </> 
  )
}

export default SecuritySettings;